var map = {
	"./": "6bcc",
	"./createDocument": "7f02",
	"./createDocument.js": "7f02",
	"./getDocumentContent": "a6d3",
	"./getDocumentContent.js": "a6d3",
	"./getDocumentFolders": "6443",
	"./getDocumentFolders.js": "6443",
	"./getDocumentsFolderContent": "3e8e",
	"./getDocumentsFolderContent.js": "3e8e",
	"./getDocumentsList": "525a",
	"./getDocumentsList.js": "525a",
	"./index": "6bcc",
	"./index.js": "6bcc",
	"./patchDocument": "8d6c",
	"./patchDocument.js": "8d6c",
	"./readLocalDocument": "2c6a",
	"./readLocalDocument.js": "2c6a",
	"./refreshDocuments": "8181",
	"./refreshDocuments.js": "8181",
	"./updateDocument": "477a",
	"./updateDocument.js": "477a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "860c";